import { apiConfig } from 'config';
import { handle420 } from 'apis/HandleError';
import { fetchdata } from '../FetchData';

export function addProvisionSu(deviceId, body) {
  const url = apiConfig.cmServiceAddProvisionSu(deviceId);

  return fetchdata(url, { method: 'POST', body: JSON.stringify(body) })
    .then((result) => {
      return result;
    })
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
}
